import { signInFormSelector } from './sign-in-email-validation-helpers';

/**
 * @deprecated
 * TODO get rid of getSignInEmailFromDom when we build headless amplify by proposed designs
 */
export const getSignInEmailFromDom = (): string => {
  if (typeof document === 'undefined') {
    return '';
  }
  const form = document.querySelector<HTMLFormElement>(signInFormSelector);
  if (!form) {
    return '';
  }
  const data = new FormData(form);
  // Amplify uses username field for email
  const email = data.get('username');
  if (typeof email === 'string') {
    const trimmed = email.trim();
    if (trimmed !== '') {
      return trimmed;
    }
  }
  return '';
};
